import { Link } from 'react-router-dom';
import { IconArrowRight, IconSparkles } from '@tabler/icons-react';
import { useTranslation } from '../../../../../i18n/hooks/useTranslation';

/**
 * The way across from a free tool to its paid AI counterpart.
 *
 * Both AI tools do by themselves what the free tool asks you to do by hand —
 * mark every photo, or type the page out. That is worth knowing while you are
 * doing the manual work, not buried in the tools grid, so each free tool carries
 * this card. It says what the AI does and what a run costs, so nobody arrives at
 * a paid tool without having been told it is paid.
 *
 * @param {{ to: string, titleKey: string, bodyKey: string }} props
 */
export default function AiToolLink({ to, titleKey, bodyKey }) {
    const { t } = useTranslation();
    return (
        <Link
            to={to}
            className="group block rounded-2xl border border-amber-200 bg-gradient-to-br from-amber-50 to-white p-3.5 transition-colors hover:border-amber-300 dark:border-amber-900/40 dark:from-amber-950/20 dark:to-zinc-900"
        >
            <span className="flex items-center gap-2">
                <span className="flex h-7 w-7 flex-none items-center justify-center rounded-lg bg-amber-100 text-amber-600 dark:bg-amber-900/40 dark:text-amber-400">
                    <IconSparkles size={16} stroke={1.9} />
                </span>
                <span className="flex-1 text-[13px] font-semibold text-[#3D3833] dark:text-zinc-100">
                    {t(titleKey)}
                </span>
                <IconArrowRight
                    size={15}
                    stroke={2}
                    className="flex-none text-amber-500 transition-transform group-hover:translate-x-0.5"
                />
            </span>
            <span className="mt-1.5 block text-[12px] leading-relaxed text-[#6B635C] dark:text-zinc-400">
                {t(bodyKey)}
            </span>
        </Link>
    );
}
